// src/forum/authHeaders.js
import { readLegacyAuthToken } from "../security/legacyAuth";

export function getStoredAuthToken() {
  return readLegacyAuthToken();
}

export function buildAuthHeaders(extra = {}) {
  const token = getStoredAuthToken();
  return {
    ...extra,
    ...(token ? { Authorization: `Token ${token}` } : {}),
  };
}
